import { css } from 'emotion'
import { H2 } from './..'

export const UserNavStyle = css({
  'h2': {
    ...H2,
    textAlign: 'center',
    marginTop: '4rem',
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/userNav.js